import React from 'react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Button, Link } from '@/theme/index';

export function JoinButton() {
  const {
    links: { joinLink },
  } = useAppConstantsContext();
  return (
    <Link href={joinLink} data-cy="join_today_btn" sx={{ alignSelf: 'center' }}>
      <Button variant="contained" color="success" sx={{ width: '140px' }}>
        Join today
      </Button>
    </Link>
  );
}
